import { Button, Checkbox, IconButton, Snackbar, TextField } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import irrImg from '../../../assets/auth-bg.svg';
import { isEmpty, isValidEmail, sanitizeEmail } from '../../../utils/functions/common.util';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import useAPI from '../../../hooks/useApi';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [message, setMessage] = useState('');
  const [open, setOpen] = React.useState(false);
  const { POST } = useAPI();
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleLogin = async () => {
    const trimmedEmail = await sanitizeEmail(email);
    if (isEmpty(trimmedEmail)) {
      setError('Email is required');
      return;
    }
    if (isEmpty(password)) {
      setPasswordError('Password is required');
      return;
    }
    if (!isValidEmail(trimmedEmail)) {
      setError('Please enter a valid email address');
      return;
    }
    setLoading(true);
    console.log("Requesting Password:", { email: trimmedEmail, password });
    const response = await POST('admin-login', { email: trimmedEmail, password });
    setLoading(false);
    if (response?.status) {
      localStorage.setItem("token", response.token);
      navigate('/tenant/dashboard');
      setMessage(response.message);
      setOpen(true);
    } else {
      setMessage(response.message);
    }
    setError('');
  }

  return (
    <div className='flex h-screen p-2 bg-house-pattern bg-tr-white justify-center bg-no-repeat bg-center bg-cover bg-blend-color-burn items-center'>
      <img draggable="false" className='fixed top-auto' width={450} src={irrImg} alt="bg" />
      <div className='shadow z-10 px-5 pt-10 pb-20 m-auto w-full max-w-[30rem] bg-white text-center'>
        <h3 className='text-3xl font-bold text-austel-green mb-3'>Login</h3>
        <span className='text-austel-green text-base block mb-2'>Welcome Back</span>
        <CustomTextField
          label="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          error={!!error}
          helperText={error}
        />
        <CustomTextField
          label="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          error={!!passwordError}
          helperText={passwordError}
        />
        <div className='mt-3 flex text-xs text-gray-700 text-left mb-4 items-center'>
          <Checkbox style={{ padding: '0' }} size='small' />
          <span className='ml-1'>Remember me</span>
        </div>
        <Link to="/forget-password" className='text-sm text-green-500'><span>Forgot password?</span></Link>
        {loading ?
          <button disabled className='text-white bg-austel-green py-2 px-20 my-2 block mx-auto text-sm rounded'>Loading...</button> :
          <button onClick={handleLogin} className='text-white bg-austel-green py-2 px-20 my-2 block mx-auto text-sm rounded'>Login</button>
        }
        <span className="text-xs">Don't have an account? <Link className='text-austel-green' to="/tenant/signup">Register</Link></span>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
        action={action}
      />
    </div>
  )
}

const CustomTextField = (props) => {
  const styles = {
    label: {
      fontSize: 14
    },
    inputP: {
      fontSize: 14,
      marginBottom: 10
    }
  }
  return <>
    <TextField
      variant='standard'
      end
      size='small'
      fullWidth
      InputLabelProps={{ style: styles.label }}
      InputProps={{
        style: styles.inputP
      }}
      {...props}
    />
  </>
}